module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('h1', {
    staticClass: "Prelim-head",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("My heartfelt gratitude goes to my father, Bashai Tekie Teclemariam, and my mother, Letehaimanot Negusse, who brought me up with the morals and education that paved the way for my life’s journey. I would also like to thank my children who have been understanding and patient for the time I sacrificed for this work when I should have paid attention to them.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("I am, besides, very grateful to the late Baheru Wolde Rufael for translating the work from Tigrigna into Amharic and Mengistu Wolde Mariam for developing and editing the work, as well as translating it into English.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-text"
  }, [_vm._v("Above all, I am eternally indebted to my wife, Sara Zerezghi, who has stood by my side all the while and without whose love and support I could not have fulfilled my long-time dream.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20cdda19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781528957960_EPUB-4.vue
// module id = 69
// module chunks = 0